// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-button-help__icon{vertical-align:sub}.e-button-help__text{position:relative}.e-button-help__text:before{content:\"\";position:absolute;bottom:1px;right:0;width:98%;height:1px;opacity:.3;background:var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
